import React, {useState} from 'react';
import classes from "./PostButtons.module.scss";
import {ReactComponent as Like} from "../../../../submodules/naoo-web-components/Shared/UI/assets/like.svg";
import {ReactComponent as CommentIcon} from "../../../../submodules/naoo-web-components/Shared/UI/assets/comment_Icon.svg";
import {ReactComponent as QRIcon} from "../../../../submodules/naoo-web-components/Shared/UI/assets/qr.svg";
import {BUTTON_TYPES, Button} from "../../../../submodules/naoo-web-components/Components/Button/Buttons";
import {ReactComponent as Check} from "../../../../submodules/naoo-web-components/Shared/UI/assets/check.svg";
import {createDeepLink, setStatus, updatePostThunk} from "../../../../store/reducers/postsReducer";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {ROUTES} from "../../../../submodules/naoo-web-components/Shared/constants";
import {Preloader} from "../../../../submodules/naoo-web-components/Components/Preloader/Preloader";

const PostButtons = ({post}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [isCopy, setIsCopy] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const handleQrCodeClick = () => {
        navigate(`${ROUTES.ADMIN_DASHBOARD.POSTS}/${post.id}/qr`)
    }

    const handleCopyDeepLinkClick = () => {
        setIsLoading(true)
        dispatch(createDeepLink({
            postId: post.id
        }))
            .then(result => {
                return navigator.clipboard.writeText(result.payload.shortLink)
            })
            .then(() => {
                setIsCopy(true)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handleFeaturePostButtonClick = () => {
        dispatch(updatePostThunk({
            id: post.id,
            post:{
                naooFeaturedVideo: !post?.naooFeaturedVideo
            }
        })).then(()=>{
            dispatch(setStatus(null))
        })
    }

    return (
        <div className={classes.Buttons}>
            <div className={classes.SocialButtons}>
                <Like
                    className={post?.userLiked ? classes.LikeActive : null}
                    width={20}
                    height={20}
                /> <span>{post?.likesCount}</span>
                <CommentIcon
                    width={20}
                    height={20}
                />
                <span>{post?.commentsCount}</span>
                <QRIcon
                    width={20}
                    height={20}
                    onClick={handleQrCodeClick}
                />
            </div>
            <div className={classes.Right}>

            </div>
            <Button
                variant={BUTTON_TYPES.NOT_ROUNDED}
                className={`${classes.CopyButton} ${classes.RightMargin}`}
                onClick={handleCopyDeepLinkClick}
            >
                {
                    isLoading
                        ? <Preloader/>
                        : isCopy
                            ? <><Check height={18}/> LINK COPIED</>
                            : 'COPY LINK '
                }
            </Button>
            <Button
                variant={BUTTON_TYPES.NOT_ROUNDED}
                className={classes.CopyButton}
                onClick={handleFeaturePostButtonClick}
            >
                {
                    post?.naooFeaturedVideo
                            ? 'FEATURED'
                            : 'FEATURE THIS POST'
                }
            </Button>
        </div>
    );
};

export default PostButtons;